(() => {
  'use strict';

  const mobile = () => window.matchMedia('(max-width: 749px)').matches;
  const normalize = (value) => String(value || '').replace(/\s+/g, ' ').trim();

  const swipeHeading = (heading, count) => {
    if (count <= 1) return '';
    const lower = heading.toLocaleLowerCase('nl-NL');
    if (lower === 'alle matchboox') return `Swipe door alle ${count} MatchBoox-uitgaven`;
    if (lower === 'series') return `Swipe door alle ${count} MatchBoox-series`;
    if (lower === 'losse boekjes') return `Swipe door alle ${count} losse MatchBoox-boekjes`;
    if (lower === 'nieuw verschenen') return `Swipe door de ${count} nieuw verschenen MatchBoox-uitgaven`;
    return `Swipe door de ${count} uitgaven van ${heading}`;
  };

  const updateDiscoveryIntro = (scope = document) => {
    scope.querySelectorAll?.('.mb-discovery:not(.mb-discovery--recommendations-only) .mb-discovery__intro h2').forEach((title) => {
      if (!title.dataset.mbDesktopHtml) title.dataset.mbDesktopHtml = title.innerHTML;
      const original = normalize(title.dataset.mbDesktopHtml.replace(/<br\s*\/?\s*>/gi, ' '));
      if (original !== 'Blader door de volledige MatchBoox-collectie') return;
      if (mobile()) {
        if (title.textContent !== 'Swipe door de volledige MatchBoox-collectie') {
          title.textContent = 'Swipe door de volledige MatchBoox-collectie';
        }
      } else if (title.innerHTML !== title.dataset.mbDesktopHtml) {
        title.innerHTML = title.dataset.mbDesktopHtml;
      }
    });
  };

  const updateResultHeadings = (scope = document) => {
    scope.querySelectorAll?.('.mb-discovery:not(.mb-discovery--recommendations-only) .mb-discovery__products-head h3').forEach((title) => {
      if (!title.dataset.mbDesktopHeading) title.dataset.mbDesktopHeading = normalize(title.textContent);
      const original = title.dataset.mbDesktopHeading;
      const match = original.match(/^(.*?)\s*\((\d+)\s+uitgav(?:e|en)\)$/i);
      if (!mobile() || !match || Number(match[2]) <= 1) {
        if (title.textContent !== original) title.textContent = original;
        title.removeAttribute('data-mb-mobile-swipe');
        return;
      }
      const mobileHeading = swipeHeading(normalize(match[1]), Number(match[2]));
      if (title.textContent !== mobileHeading) title.textContent = mobileHeading;
      title.dataset.mbMobileSwipe = 'true';
    });
  };

  const updateMakerIntro = (page) => {
    const isAuthorPage = page.dataset.pageHandle === 'auteurs';
    const sentence = [...page.querySelectorAll('.mb-v126-maker-hero .mb-intro p, #mb-auteurs > .mb-intro p, #mb-illustratoren > .mb-intro p')]
      .find((paragraph) => /klik op de afbeelding/i.test(paragraph.textContent));
    if (!sentence) return;
    if (!sentence.dataset.mbDesktopCopy) sentence.dataset.mbDesktopCopy = sentence.textContent;
    const copy = mobile()
      ? `Tik op de afbeelding om het betreffende boekje of de serie te bekijken. Heeft ${isAuthorPage ? 'een auteur' : 'een illustrator'} meerdere uitgaven, swipe dan door de afbeeldingen.`
      : sentence.dataset.mbDesktopCopy;
    if (sentence.textContent !== copy) sentence.textContent = copy;
  };

  const showMakerCard = (block, nextIndex) => {
    const cards = [...block.querySelectorAll('.mb-book-card')];
    if (cards.length < 2) return;
    const current = Math.max(0, cards.findIndex((card) => card.classList.contains('is-active')));
    const index = Math.min(cards.length - 1, Math.max(0, nextIndex));
    if (index === current) return;
    cards.forEach((card, cardIndex) => {
      card.classList.toggle('is-active', cardIndex === index);
      card.setAttribute('aria-hidden', cardIndex === index ? 'false' : 'true');
    });
  };

  const enableMakerSwipe = (page) => {
    page.querySelectorAll('.mb-author-block, .mb-illustrator-block').forEach((block) => {
      if (block.dataset.mbMobileSwipeReady === 'true') return;
      const strip = block.querySelector('.mb-book-strip');
      const cards = [...block.querySelectorAll('.mb-book-card')];
      if (!strip || cards.length < 2) return;
      block.dataset.mbMobileSwipeReady = 'true';
      let startX = 0;
      let startY = 0;
      strip.addEventListener('touchstart', (event) => {
        startX = event.changedTouches[0]?.clientX || 0;
        startY = event.changedTouches[0]?.clientY || 0;
      }, { passive: true });
      strip.addEventListener('touchend', (event) => {
        if (!mobile()) return;
        const endX = event.changedTouches[0]?.clientX || 0;
        const endY = event.changedTouches[0]?.clientY || 0;
        const horizontal = endX - startX;
        const vertical = endY - startY;
        if (Math.abs(horizontal) < 42 || Math.abs(horizontal) <= Math.abs(vertical)) return;
        const current = Math.max(0, cards.findIndex((card) => card.classList.contains('is-active')));
        showMakerCard(block, current + (horizontal < 0 ? 1 : -1));
      }, { passive: true });
    });
  };

  const apply = (scope = document) => {
    updateDiscoveryIntro(scope);
    updateResultHeadings(scope);
    scope.querySelectorAll?.('.mb-page-content[data-page-handle="auteurs"], .mb-page-content[data-page-handle="illustratoren"]')
      .forEach((page) => {
        updateMakerIntro(page);
        enableMakerSwipe(page);
      });
  };

  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(() => {
      queued = false;
      apply();
    });
  };

  const init = () => {
    apply();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('shopify:section:load', (event) => apply(event.target));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
